<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <erklaerung-arag-mental />
        <!-- <div class="ion-margin-vertical">
          <img width="50" src="@/assets/img/arag_logo.png" />
        </div> -->
        <div class="c-cta">
          <ion-button class="ion-margin-top" @click="openFormContact"
            >Jetzt Kontakt aufnehmen&nbsp;
            <ion-icon
              :src="require('@lib/assets/icons/roodie-white.svg')"
              slot="end"></ion-icon
          ></ion-button>
        </div>
        <!-- <ion-row class="ion-margin-top">
          <ion-col size="auto">
            <ion-icon :src="require('@lib/assets/icons/info.svg')" />
          </ion-col>
          <ion-col>
            <ion-text color="primary" class="u-xsmall">
              Das Angebot von Selfapy, therapeutenverbund.de, und MindDoc ist
              eine Zusatzleistung des jeweiligen Kooperationspartners. Sie kann
              jederzeit entfallen, wenn die Kooperation endet.
            </ion-text>
          </ion-col>
        </ion-row> -->
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonBackButton,
  // IonRow,
  // IonCol,
  // IonText,
  modalController,
} from "@ionic/vue";
import FormContact from "@/components/FormContact";
import ErklaerungAragMental from "@/components/ErklaerungAragMental";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonBackButton,
    // IonRow,
    // IonCol,
    // IonText,
    ErklaerungAragMental,
  },
  data() {
    return {};
  },
  methods: {
    async openFormContact() {
      const modal = await modalController.create({
        component: FormContact,
        componentProps: {
          routing: "ARAG Case Management Mental",
          reference: "Kontakt aufnehmen",
        },
      });
      return modal.present();
    },
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
